"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentGridView = exports.SectionContainer = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Block_1 = require("../Block");

var Row_1 = require("../Row");

var Typography_1 = require("../Typography");

exports.SectionContainer = styled_components_1["default"].div(_templateObject(), function (props) {
  return props.theme['@size-l'];
});

function FragmentGridView(_ref) {
  var sections = _ref.sections,
      itemKey = _ref.itemKey,
      renderGridItem = _ref.renderGridItem;
  var results = sections.map(function (_ref2) {
    var title = _ref2.title,
        titleProps = _ref2.titleProps,
        items = _ref2.items,
        key = _ref2.key;
    return react_1["default"].createElement(exports.SectionContainer, {
      key: key
    }, title ? react_1["default"].createElement(Block_1.Block, {
      marginBottom: '@size-m'
    }, react_1["default"].createElement(Typography_1.H3, Object.assign({
      isBlock: false
    }, titleProps), title)) : null, react_1["default"].createElement(Row_1.Row, null, items.map(function (item) {
      return react_1["default"].createElement(antd_1.Col, {
        key: typeof itemKey === 'function' ? itemKey(item) : item[itemKey],
        xs: 24,
        md: 12,
        lg: 8,
        xxl: 6
      }, react_1["default"].createElement(Block_1.Block, {
        marginBottom: '@size-s'
      }, renderGridItem(item)));
    })));
  });
  return react_1["default"].createElement(react_1["default"].Fragment, null, results);
}

exports.FragmentGridView = FragmentGridView;